import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  LIFECYCLE_STAGE_TENDER_COLORS,
  LIFECYCLE_STAGE_TENDER_LABELS,
  type LifecycleStageTender,
} from '@/constants/lifecycleStages';

interface Props {
  stage: LifecycleStageTender | null | undefined;
  className?: string;
}

export default function TenderLifecycleStageBadge({ stage, className }: Props) {
  if (!stage) {
    return (
      <span className={cn('text-[10px] text-muted-foreground', className)}>
        Chưa set
      </span>
    );
  }
  return (
    <Badge
      variant="outline"
      className={cn(
        'inline-flex items-center gap-1 text-[10px] px-2 py-0.5 font-semibold rounded-md border',
        LIFECYCLE_STAGE_TENDER_COLORS[stage],
        className,
      )}
    >
      {LIFECYCLE_STAGE_TENDER_LABELS[stage]}
    </Badge>
  );
}
